module.exports = __webpack_public_path__ + "img/icon-chatting.1af24caf.png";